import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import APICaller from 'utils/APICaller';

const initialState = {
  creditCustomerListing: [],
  customerDetails: [],
  customerLedgerData: [],
  tableReload: false
};

export const getCreditCustomerListing = createAsyncThunk(
  '/credit/customers',
  async ({ params }) => {
    const response = await APICaller({
      method: 'get',
      url: 'apifinance/credit/customers',
      offurl: '/dummy/table',
      params
    });
    return response;
  }
);

export const getCustomerDetails = createAsyncThunk(
  '/credit/customer-details',
  async ({ customerId }) => {
    const response = await APICaller({
      method: 'get',
      url: `apifinance/credit/customer-details/${customerId}`,
      offurl: '/dummy/table'
    });
    return response;
  }
);

export const getCustomerLedgerData = createAsyncThunk(
  '/credit/ledger',
  async ({ customerId, params }) => {
    const response = await APICaller({
      method: 'get',
      url: `apifinance/credit/ledger/${customerId}`,
      offurl: '/dummy/table',
      params
    });
    return response;
  }
);

export const updateBookedOrderToggle = createAsyncThunk(
  'credit/update',
  async ({ customerId, body }) => {
    const response = await APICaller({
      method: 'patch',
      url: `apifinance/credit/update/${customerId}`,
      offurl: '/dummy/table',
      data: body
    });
    return response;
  }
);

export const customerCreditSlice = createSlice({
  name: 'customerCredit',
  initialState,
  reducers: {
    tableReloader: (state) => {
      state.tableReload = !state.tableReload;
    },
    resetCustomerCreditState: (state) => {
      state.customerDetails = [];
      state.customerLedgerData = [];
    }
  },
  extraReducers: {
    [getCreditCustomerListing.fulfilled]: (state, { payload }) => {
      state.creditCustomerListing = payload;
    },
    [getCustomerDetails.fulfilled]: (state, { payload }) => {
      state.customerDetails = payload;
    },
    [getCustomerLedgerData.fulfilled]: (state, { payload }) => {
      state.customerLedgerData = payload;
    }
  }
});
export const { tableReloader, resetCustomerCreditState } = customerCreditSlice.actions;

export default customerCreditSlice.reducer;
